/* eslint-disable jsx-a11y/no-static-element-interactions */
import Button from '@/components/Button';
import React, { useEffect, useState } from 'react';
import { AnswerProps, useDailyAnswerStore } from '../useDailyAnswer';
import { Input } from '@/components/ui/input';
import { onCompletedOnBoardingWeeklyQuestion } from '@/services/on-boarding/onboarding.service';
import { getAuthentication } from '@/hooks/useAuthentication';
import { clearSurveyDataLayer, trackSurvey } from '@/lib/ga-custom-events/survey';

export const SubmitQuestions = ({
  selectedAnswer,
  setFinished,
}: {
  selectedAnswer: AnswerProps[];
  setFinished: React.Dispatch<boolean>;
}) => {
  const { onAnswer } = useDailyAnswerStore();
  const [submmited, setSubmmited] = useState(false);
  const [comment, setComment] = useState('');
  const { user } = getAuthentication();

  const onPressThanksCardAction = async (sendComment: boolean) => {
    setSubmmited(true);

    await new Promise((resolve) => setTimeout(resolve, 3000));
    Promise.all(
      selectedAnswer.map(
        async (answer) => await onAnswer({ ...answer, comment: sendComment ? comment : '' } as AnswerProps),
      ),
    );

    setTimeout(() => {
      setFinished(true);
    }, 3000);

    if (user?.id) {
      onCompletedOnBoardingWeeklyQuestion(user?.id);
    }

    selectedAnswer.forEach((answer) => {
      trackSurvey({
        date: new Date().toISOString(),
        surveyQuestion: answer.currentQuestion.attributes!.question || '-',
        surveyAnswer: answer.option.option || '-',
        surveyAnswerFeedback: sendComment ? comment : '',
      });
    });
    setComment('');
  };

  useEffect(() => {
    return () => {
      clearSurveyDataLayer();
    };
  });

  const renderThanksCard = () => {
    return (
      <>
        <p className="mb-sh-15 line-clamp-2 h-8 text-center text-sh-xxxs font-bold">
          Thank you! Please let us know if you have any additional comments
        </p>

        <div className="w-full">
          <Input
            as="textarea"
            placeholder={'Any comments?'}
            type="text"
            name="suggest"
            onChange={(e) => {
              setComment(e.target.value);
            }}
          />
        </div>
        <div className="flex gap-sh-15">
          <Button theme={'solid'} className=" mt-sh-30" onClick={() => onPressThanksCardAction(true)}>
            Submit
          </Button>

          <Button theme={'solid'} className=" mt-sh-30" onClick={() => onPressThanksCardAction(true)}>
            No, thanks
          </Button>
        </div>
      </>
    );
  };

  return (
    <div className="flex min-h-[173px] w-[366px] flex-col items-center justify-center rounded-2xl border border-[#A1C3EC] bg-white  p-sh-30 md:w-[415px]">
      {selectedAnswer && !submmited && renderThanksCard()}
      {submmited && (
        <div className="flex min-h-[100px] items-center justify-center">
          <p className="grow text-center text-sh-sm">Thank you for your feedback</p>
        </div>
      )}
    </div>
  );
};
